// src/components/TimeCard.ts
import "./TimeCard.css";

export function renderTimeCard(container: HTMLElement): void {
  const now = new Date();

  const time = now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  const date = now.toLocaleDateString([], {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  container.innerHTML = `
    <div class="timecard-container">
      <div class="timecard-time">${time}</div>
      <div class="timecard-date">${date}</div>
    </div>
  `;
}
